//Reducer

const defaultState = {
    type: "",
    scene: {},
};
const sceneReducer = (state = defaultState, action) => {
    switch (action.type) {
        case "SET_SCENE":
            return {
                type: "SET_USER",
                scene: action.scene,
            };
        case "UN_SET_Scene":
            return {
                type: "UN_SET_USER",
                scene: {},
            };
        default:
            return state;
    }
};

export default sceneReducer;
